import { c as _c } from "react/compiler-runtime";
import { Center, Spinner } from '@chakra-ui/react';
import { DiagnosticShell } from '@src/components/sco/Advisors/ClarityAdvisorImportDiagnostic/DiagnosticShell';
import { useClarityAdvisorImport } from '@src/components/sco/Advisors/hooks/useClarityAdvisorImport';
import { ClarityAdvisorImportView } from '@src/components/sco/Advisors/sections/ClarityAdvisorImportView';
import { ScoClarityAdvisorImportClaimStatus } from '@src/graphql-types';
export type ClarityAdvisorImportDiagnosticProps = {
  handle: string;
  focused?: boolean;
  onDismiss?: () => void;
};
export const ClarityAdvisorImportDiagnostic = t0 => {
  const $ = _c(20);
  const {
    handle,
    focused: t1,
    onDismiss
  } = t0;
  const focused = t1 === undefined ? false : t1;
  const importState = useClarityAdvisorImport(handle);
  let t2;
  if ($[0] !== handle || $[1] !== importState.applyHref || $[2] !== importState.becomeHref || $[3] !== importState.claimStatus || $[4] !== importState.claiming || $[5] !== importState.error || $[6] !== importState.expert || $[7] !== importState.extracting || $[8] !== importState.holdPhase || $[9] !== importState.isRegistered || $[10] !== importState.loading || $[11] !== importState.loginHref || $[12] !== importState.onConfirm || $[13] !== importState.proof || $[14] !== importState.sendingCode) {
    t2 = importState.loading ? <Center minHeight="12rem" width="full"><Spinner colorPalette="orange" size="lg" /></Center> : <ClarityAdvisorImportView embedded={true} applyHref={importState.applyHref} becomeHref={importState.becomeHref} claiming={importState.claiming} claimStatus={importState.claimStatus || ScoClarityAdvisorImportClaimStatus.NotFound} error={importState.error} expert={importState.expert} extracting={importState.extracting} handle={handle} holdPhase={importState.holdPhase} isRegistered={importState.isRegistered} loginHref={importState.loginHref} proof={importState.proof} sendingCode={importState.sendingCode} onConfirm={importState.onConfirm} />;
    $[0] = handle;
    $[1] = importState.applyHref;
    $[2] = importState.becomeHref;
    $[3] = importState.claimStatus;
    $[4] = importState.claiming;
    $[5] = importState.error;
    $[6] = importState.expert;
    $[7] = importState.extracting;
    $[8] = importState.holdPhase;
    $[9] = importState.isRegistered;
    $[10] = importState.loading;
    $[11] = importState.loginHref;
    $[12] = importState.onConfirm;
    $[13] = importState.proof;
    $[14] = importState.sendingCode;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== focused || $[17] !== onDismiss || $[18] !== t2) {
    t3 = <DiagnosticShell focused={focused} onDismiss={onDismiss}>{t2}</DiagnosticShell>;
    $[16] = focused;
    $[17] = onDismiss;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  return t3;
};